import { render, staticRenderFns } from "./BuyersClub.vue?vue&type=template&id=564e7db4&scoped=true&"
import script from "./BuyersClub.vue?vue&type=script&lang=ts&"
export * from "./BuyersClub.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersClub.vue?vue&type=style&index=0&id=564e7db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e7db4",
  null
  
)

export default component.exports